function initialiseShareLinks(): void {
    const pageUrl = encodeURIComponent(window.location.href);
    const pageTitle = encodeURIComponent(document.title);

    const facebook = document.querySelector<HTMLAnchorElement>('[data-share-facebook]');
    if (facebook) {
        facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
    }

    const x = document.querySelector<HTMLAnchorElement>('[data-share-x]');
    if (x) {
        x.href = `https://twitter.com/intent/tweet?url=${pageUrl}&text=${pageTitle}`;
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseShareLinks);
} else {
    initialiseShareLinks();
}
